import l10n from '../l10n/localization';

export default {
    email: {
        email: {
            message: "invalid email address"
        },
        presence: {
            message: l10n.validation.required,
        },
    },
    password: {
        presence: {
            message: l10n.validation.required,
        },
    },
};



// WEBPACK FOOTER //
// ./src/validation/login.js